import ToggleDeclaration from "./ToggleDeclaration";

const AssistenceDeclaration = () => {
  return (
    <ToggleDeclaration
      title="Do you need assistance for this run? "
      toggleLabel="I would like to request the help of a lab expert to assist with using the equipment during this run."
      toggleSubtext="If your plans change, you can edit your booking to cancel this request."
      fieldName="withAssistance"
      textFieldName="assistanceReason"
      textareaPlaceholder="Please tell us a few words about why you need assistance."
      toggleType="slide"
      invertToggleLogic={false}
      alwaysShowTextarea={true}
      disableTextAreaWhenToggledOff={true}
    />
  );
};

export default AssistenceDeclaration;
